import {
  GET_AUDIENCE_BUILDERS_FAILURE,
  GET_AUDIENCE_BUILDERS_REQUEST,
  GET_AUDIENCE_BUILDERS_SUCCESS,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const audienceBuilders = (state = initialState, action) => {
  const types = {
    [GET_AUDIENCE_BUILDERS_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_AUDIENCE_BUILDERS_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [GET_AUDIENCE_BUILDERS_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default audienceBuilders;
